<section>
  <div *ngIf="selection.selected.length > 0" class="selection-action-section">
    <button
      mat-stroked-button
      color="primary"
      (click)="createMinuteWithWarranties()"
    >
      Nueva minuta
    </button>
      <button
      mat-stroked-button
      *ngIf="permisionApprovedWarranty"
      color="secondary"
      (click)="approvedMultiWarranties()"
      style="background-color: green; color: white; font-weight: 600; margin-left:10px;"
    >
      Aprobar
    </button>
      <button
      mat-stroked-button
      color="secondary"
      *ngIf="permisionRejectWarranty"
      (click)="rejectMultiWarranties()"
      style="background-color: red; color: white; font-weight: 600; margin-left:10px;"
    >
      Rechazar
    </button>
  </div>
  <div class="overflow-table">
    <table mat-table
     matSort 
     [dataSource]="dataSource"
     matSortDirection="desc"
     matSortActive="createdAt">
      <ng-container matColumnDef="selectionColumn">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element) : null"
            [checked]="selection.isSelected(element)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Finalidad -->
      <ng-container matColumnDef="warrantyType">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.warrantyType }}</h6>
        </td>
      </ng-container>

      <!-- Asegurador -->
      <ng-container matColumnDef="insuranceCompany">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Aseguradora</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.insuranceCompany }}</h6>
        </td>
      </ng-container>

      <!-- Fecha solicitud -->
      <ng-container matColumnDef="createdAt" >
        <th class="th-header" mat-header-cell  *matHeaderCellDef>Solic.</th>
        <td class="mat-body-1" mat-cell *matCellDef="let element">
          <h6>{{ element.createdAt | date : "dd-MM-yyyy" }}</h6>
        </td>
      </ng-container>

      <!-- Codigo Licitacion-->
      <ng-container matColumnDef="tender">
        <th class="th-header" mat-header-cell mat-sort-header *matHeaderCellDef>Lic.</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.tender }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Monto</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.amount | currency : "CLP" }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="amountType">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Moneda</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.amountType }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="cost">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Comisión</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.cost | currency : "CLP" }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="nameTenderBuyer">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Mandante</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.nameTenderBuyer }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="requestDate">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Desde</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.requestDate | date : "dd-MM-yyyy" }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Hasta</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.endDate | date : "dd-MM-yyyy" }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="tasa">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Tasa (%)</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.tasa | number : "1.2-2" }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="insuranceBroker">
        <th class="th-header" mat-header-cell *matHeaderCellDef>Corredor</th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.insuranceBroker }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="isForBuilding">
        <th class="th-header" mat-header-cell *matHeaderCellDef>
          Construcción
        </th>
        <td mat-cell *matCellDef="let element">
          <h6>{{ element.isForBuilding }}</h6>
        </td>
      </ng-container>

      <ng-container matColumnDef="contractAmount">
        <th class="th-header" mat-header-cell *matHeaderCellDef>
          Tamaño contrato
        </th>
        <td mat-cell *matCellDef="let element">
          <h6>{{element.contractAmount | currency: 'CLP'}}</h6>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
      <tr
        mat-row
        [cdkContextMenuTriggerFor]="menu"
        *matRowDef="let row; columns: displayCols"
        class="cursor_table"
        style="cursor:pointer"
      >
        <ng-template #menu>
          <div
            cdkMenu
            class="context_menu mat-elevation-z0"
            style="z-index: 999;"
          >
          <ul>
              <li>
                <button
                  *ngIf="permisionApprovedWarranty"
                  class="context-menu-item trash"
                  cdkMenuItem
                  mat-raised-button
                  (click)="approved(row.warrantyId, row.warrantyType, row.amount, row.tender, row.isForBuilding)"
                  style="background-color: green; color: white; font-weight: 600"
                >
                  Aprobar
                </button>
              </li>
              <li>
                <button
                  style="margin-top:10px"
                  class="context-menu-item trash"
                  cdkMenuItem
                  *ngIf="permisionRejectWarranty"
                  mat-raised-button
                  style="background-color: red; color: white; font-weight: 600"
                  (click)="rejectWarranty(row.warrantyId, row.warrantyType, row.amount,  row.tender)"             
                >
                  Rechazar
                </button>
              </li>
              <li>
                <button
                  style="margin-top:10px"
                  class="context-menu-item trash"
                  cdkMenuItem
                  mat-raised-button
                  (click)="createMinute(row)"             
                >
                  Nueva Minuta
                </button>
              </li>
              <li>
                <button (click)="updateWarrantyAmount(row)" class="context-menu-item" mat-raised-button>
                  Modificar tamaño contrato            
                </button>              
              </li>
          </ul>
          </div>
        </ng-template>
      </tr>
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</section>